export class DrawerProductOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['option']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'change', this.onProductOptionChange.bind(this))

    for (const option of this.els.option.elements) {
      this.listeners.add(
        option,
        'mouseenter',
        this.onProductOptionEnter.bind(this),
      )
    }
  }

  onProductOptionChange (event) {
    const target = event.target

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_SELECTED, {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  onProductOptionEnter (event) {
    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_ENTERED, {
      event,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  get selectedOptionValues () {
    const selectedOptions = Array.from(this.querySelectorAll('select')).flatMap(
      (select) =>
        Array.from(select.selectedOptions).map(
          (option) => option.dataset.optionValueId,
        ),
    )

    const checkedInputs = Array.from(
      this.querySelectorAll('fieldset input:checked'),
    ).map((input) => input.dataset.optionValueId)

    return [...selectedOptions, ...checkedInputs]
  }
}

if (!customElements.get('drawer-product-options')) {
  customElements.define('drawer-product-options', DrawerProductOptions)
}
